import { PrimaryButton as Button } from '@shape-ds/components';

import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { usePostHog } from 'posthog-js/react';
import { InfoMessage } from '@shape/lighthouse-components';

export const ErrorFallback = ({ resetErrorBoundary, error }: FallbackProps) => {
  const { t } = useTranslation();
  const posthog = usePostHog();
  const properties = {
    message: error.message || 'Unknown error',
    stack: error.stack || 'No stack trace',
    name: error.name || 'UnknownError',
    app_version: __APP_VERSION__,
  };
  posthog?.capture('APP_CRASH', properties);
  return (
    <div className="columns is-centered">
      <div className="column is-half has-text-centered mt-4" role="alert">
        <InfoMessage
          type="error"
          title={t('glossary:error.title')}
          message={t('glossary:error.message')}
        />
        <Button onClick={resetErrorBoundary} className="mt-3">
          {t('glossary:tryAgain')}
        </Button>
      </div>
    </div>
  );
};
